import * as React from "react";

import { Text } from "../..";
import { EducationJobQualification, EducationJobTag } from "../../../domain";

export const EducationJobQualificationView = (props: {
    qual: EducationJobQualification;
}) => {
    const { educationChoiceTagId, educationChoiceTagName } =
        props.qual.education;

    return (
        <li>
            <Text variant="body1">
                {educationChoiceTagId ===
                EducationJobTag.HighSchoolOrEquivalent.id
                    ? educationChoiceTagName
                    : educationChoiceTagId === EducationJobTag.Doctorate.id
                    ? educationChoiceTagName + " degree"
                    : educationChoiceTagName + " degree or higher"}
            </Text>
        </li>
    );
};
